import {
  setAllAdvertisingAccounts,
  setAllCampaigns,
  setCompetitorMetricsAccordionDetails,
  setCostWeightchartData,
  setDailyLPExperienceDetails,
  setEngagementMetricsDetails,
  setKeywordDetailsByInternalId,
  setKeywordReleventScore,
  setKeywordsLinkedToURL,
  setPageSpeedMetricsDetails,
  setPerformanceByKeywords,
  setSingleKeywordDetails,
} from "../../../features/landingPageExperienceSlice";
import { setDisplayErrorSnackBar } from "../../../features/userSlice";
import { lpExperienceService } from "../../../services/api/lp-experience.endpoints";
import store from "../../../store";

async function getAllAdvertisementAccounts(oauthTokenHeader: string) {
  try {
    const response = await lpExperienceService.getAllAccounts(oauthTokenHeader);
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to access accounts data");
    } else {
      store.dispatch(setAllAdvertisingAccounts(response?.data?.data)); // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function getAllCampaigns(params: any) {
  try {
    const response = await lpExperienceService.getLPCampaignExecuteQuery(
      params
    );
    if (!response || !response.status || response.status !== 200) {
      store.dispatch(setAllCampaigns([]));
      throw new Error("Failed to access campaigns");
    } else {
      const campaigns = response?.data?.data?.query_output ?? [];
      //filter out null or invalid items
      const validCampaigns = campaigns.filter(
        (c: any) => c?.camp_id && c?.camp_name
      );
      store.dispatch(setAllCampaigns(validCampaigns)); // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(setAllCampaigns([]));
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function getLPCostWeightedScoreChart(params: any) {
  try {
    const response = await lpExperienceService.getCostWeightedScoreChart(
      params
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get cost weight data");
    } else {
      store.dispatch(
        setCostWeightchartData(response?.data?.data?.query_output)
      ); // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function getLPPerformanceByKeyword(params: any) {
  try {
    const response = await lpExperienceService.getPerformanceByKeyword(params);
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to access keyword performance");
    } else {
      store.dispatch(
        setPerformanceByKeywords(response?.data?.data?.query_output)
      ); // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function getSingleKeywordDetailsByInternalId(params: any) {
  try {
    const response =
      await lpExperienceService.getSingleKeywordDetailsByInternalId(params);
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to access keyword performance");
    } else {
      store.dispatch(
        setKeywordDetailsByInternalId(response?.data?.data?.query_output)
      ); // Set the fetched data
      return response;
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function getKeywordsLinkedToURL(params: any) {
  try {
    const response = await lpExperienceService.getKeywordsLinkedToURL(params);
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to access keyword performance");
    } else {
      store.dispatch(
        setKeywordsLinkedToURL(response?.data?.data?.query_output)
      ); // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function getSingleKeywordDetails(params: any) {
  try {
    const response = await lpExperienceService.getSingleKeywordDetails(params);
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to access keyword performance");
    } else {
      store.dispatch(
        setSingleKeywordDetails(response?.data?.data?.query_output)
      ); // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function getDailyLPExperienceDetails(params: any) {
  try {
    const response = await lpExperienceService.getDailyLPExperienceDetails(
      params
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed load data");
    } else {
      store.dispatch(
        setDailyLPExperienceDetails(response?.data?.data?.query_output)
      ); // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function getKeywordReleventScore(params: any) {
  try {
    const response = await lpExperienceService.getKeywordReleventScore(params);
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed load data");
    } else {
      store.dispatch(setKeywordReleventScore(response?.data?.data)); // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}
async function postKeywordReleventScore(params: any, data: any) {
  try {
    const response = await lpExperienceService.postKeywordReleventScore(
      params,
      data
    );
    if (!response || !response.status || response.status !== 201) {
      throw new Error("Failed load data");
    } else {
      store.dispatch(setKeywordReleventScore(response?.data?.data)); // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function getCompetitorMetricsAccordion(params: any) {
  try {
    const response = await lpExperienceService.getCompetitorMetricsAccordion(
      params
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed load data");
    } else {
      store.dispatch(
        setCompetitorMetricsAccordionDetails(response?.data?.data?.query_output)
      ); // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function getPageSpeedMetrics(params: any) {
  try {
    const response = await lpExperienceService.getPageSpeedMetrics(params);
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed load data");
    } else {
      store.dispatch(
        setPageSpeedMetricsDetails(response?.data?.data?.query_output)
      ); // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function getEngagementMetrics(params: any) {
  try {
    const response = await lpExperienceService.getEngagementMetrics(params);
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed load data");
    } else {
      store.dispatch(
        setEngagementMetricsDetails(response?.data?.data?.query_output)
      ); // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

export const LPExperienceEndPointLogic = {
  getAllAdvertisementAccounts,
  getAllCampaigns,
  getLPCostWeightedScoreChart,
  getLPPerformanceByKeyword,
  getSingleKeywordDetailsByInternalId,
  getKeywordsLinkedToURL,
  getSingleKeywordDetails,
  getDailyLPExperienceDetails,
  getCompetitorMetricsAccordion,
  getPageSpeedMetrics,
  getKeywordReleventScore,
  postKeywordReleventScore,
  getEngagementMetrics,
};
